import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ApispecificationService {

  constructor(
    private apiBasic: ApiBasicService,
    private api: ApiService
  ) { }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getReferences(params: any, moduleName): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {

    // return this.apiBasic.getList(params, 'specificationsHeader');
    return this.api.post('specification/list', params, 'private', 'files');
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getSpecificationsReference(params: any): Observable<Res> {

    // return this.apiBasic.getList(params, 'specificationsHeader');
    return this.api.post('specifications_list', params, 'private');
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  info(id: string): Observable<Res> {

    return this.apiBasic.getInfo('specification', id);
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  create(params: any): Observable<Res> {

    return this.api.post('specification/create', params, 'private', 'files');
    // return this.apiBasic.create('specification', params,);
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  edit(id: string): Observable<Res> {

    return this.apiBasic.edit('specification', id);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  update(params: any): Observable<Res> {

    return this.apiBasic.update('specification', params);
  }

  /**
   * 
   */
  delete(params: any): Observable<Res> {

    return this.apiBasic.deleteSpecifications(params);
  }
}
